import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificareEvidentaComponent } from './verificare-evidenta.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [VerificareEvidentaComponent],
    imports: [
        CommonModule,
        MaterialModule
    ],
    exports: [VerificareEvidentaComponent]
})
export class VerificareEvidentaModule { }
